import { Box, Button } from '@mui/material';
import React, { useEffect } from 'react';

const TallyDemoForm = () => {
    useEffect(() => {
        // Script yükleme: Tekrar yüklenmeyi önlüyoruz
        if (!document.querySelector('script[src="https://tally.so/widgets/embed.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://tally.so/widgets/embed.js';
            script.async = true;
            document.body.appendChild(script);
        }
    }, []);

    return (
        <Box
            id="demo-form"
            sx={{
                width: '100%',
                maxWidth: '400px', // Mobilde daraltılmış görünüm
                margin: '40px auto',
                padding: '20px',
                textAlign: 'center',
            }}
        >
            <Button
                data-tally-open="wMV9kA"
                data-tally-layout="modal"
                data-tally-width="400" // Daha minimal modal genişliği
                data-tally-auto-close="0"
                variant="contained"
                size="large"
                sx={{
                    py: 1.5,
                    px: 3,
                    fontSize: '1rem',
                    fontWeight: 600,
                    borderRadius: 2,
                    backgroundColor: (theme) => theme.palette.primary.main,
                    color: 'white',
                    '&:hover': {
                        backgroundColor: (theme) => theme.palette.primary.dark,
                    },
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    textTransform: 'none',
                    transition: 'all 0.3s ease',
                }}
            >
                Demo Talep Et
            </Button>
        </Box>
    );
};

export default TallyDemoForm;
